

import axios from 'axios';
import { Message } from 'element-ui';
import { CODE } from '@/api/config/xhr';

const SERVER_BASE_URL = process.env.SERVER_BASE_URL;

export default function fetch(options) {
  let headers = {};
  if (options.headers !== undefined) {
    headers = options.headers;
  } else {
    // const currlo = localStorage.getItem('currlocale')
    // let lang;
    // if (currlo === 'en-US') {
    //   lang = zh-hans
    // } else if (currlo === 'en-US') {
    //   lang = zh-hans
    // Access-Control-Allow-Origin'
    // }
    headers = {
      'Content-Type': 'application/json',
      'Accept-language': 'en-us',
      'Content-Security-Policy': 'upgrade-insecure-requests',
    };
  }
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: SERVER_BASE_URL,
      timeout: 15000,
      headers,
    });
    const temp = instance(options);
    temp.then(({ data }) => {
      const code = data.error;
      if (code === CODE.success) {
        resolve(data);
      } else {
        if (!options.url.includes('enduser/profile')) {
          Message.error(CODE[code] || code);
          if (code === 'AuthFailed'){
            sessionStorage.setItem('loginId',null);
          }
        }
        reject(data);
      }
    }).catch(() => {
      reject();
    });
  });
}



// WEBPACK FOOTER //
// ./src/common/fetch.js